'use strict';
var isObject = require('../internals/is-object');

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};



//////////////////
// WEBPACK FOOTER
// ./~/formiojs/~/core-js/internals/is-possible-prototype.js
// module id = 3063
// module chunks = 0